const pages = [
    {
        name: 'rules',
        pages: [
            'intro',
            'capture-stones',
            '50k',
            '49k',
            '48k',
            'destroy-white',
            '47k',
            'illegal-moves',
            '46k',
        ],
    },
    {
        name: 'techniques',
        pages: [
            '45k',
            '44k',
            'two-eyes',
            '43k',
            '42k',
            '41k',
            'ko',
            '40k',
            '39k',
            '38k',
            '37k',
        ],
    },
    {
        name: 'progression',
        pages: [
            'beginning',
            '36k',
            'end-game',
            'more-end-game',
            'cutting-stones',
            'defending',
            'one-point-jump',
            'more-about-jumps',
            '35k',
            '34k',
        ],
    },
    {
        name: 'preparation',
        pages: [
            'game-examples',
            'komi',
            'attachments',
            'extensions',
            'corners',
            'epilogue',
        ],
    },
];

export default pages;
